// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.dto.HpUserInteraction

export enum HpUserInteraction {
  FAVORITE = 'favorite',
  HIDE = 'hide',
  INQUIRY = 'inquiry',
  SHARE = 'share',
  TOUR = 'tour',
  VIEW = 'view',
}

export const HpUserInteraction_values = [
  HpUserInteraction.FAVORITE,
  HpUserInteraction.HIDE,
  HpUserInteraction.INQUIRY,
  HpUserInteraction.SHARE,
  HpUserInteraction.TOUR,
  HpUserInteraction.VIEW,
] as const;
